<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 10,
      height: 11,
      color: 'currentColor',
      viewBoxValue: `0 0 10 11`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="annotation-info">
      <path
        d="M4.80273 1.5V9.5M7.80273 2.5L1.80273 8.5M8.80273 5.5H0.802734M7.80273 8.5L1.80273 2.5"
        stroke="#8B5CF6"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
